export default function AboutSection() {
  return (
    <section
      id="about"
      className="relative overflow-hidden py-20 md:py-24 bg-[linear-gradient(180deg,#FFFFFF_0%,#F8FBFF_34%,#EEF6FF_60%,#FFFFFF_100%)] text-[#0F172A]"
    >
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-20 top-16 h-56 w-56 rounded-full bg-[#027FDB]/12 blur-3xl" />
        <div className="absolute right-[-4rem] top-24 h-64 w-64 rounded-full bg-[#D9EEFF]/80 blur-3xl" />
        <div className="absolute left-1/3 bottom-[-5rem] h-72 w-72 rounded-full bg-[#B9DEFF]/35 blur-3xl" />
      </div>

      <div className="relative max-w-[76rem] mx-auto px-5 sm:px-6 lg:px-8">
        <div className="mb-10 md:mb-14 max-w-[52rem]">
          <p className="inline-flex items-center rounded-full border border-[#D9EEFF] bg-white/92 px-4 py-2 text-[10px] font-semibold uppercase tracking-[0.18em] text-[#027FDB] shadow-[0_10px_24px_rgba(2,127,219,0.06)] backdrop-blur-sm">
            Über Alltagsstern
          </p>
          <h2 className="mt-5 text-3xl md:text-5xl lg:text-[3.15rem] font-semibold leading-[1.06] tracking-[-0.02em] text-[#0F172A] max-w-[46rem]">
            Alltagsstern UG unterstützt im Alltag dort, wo Entlastung gebraucht wird
          </h2>
          <p className="mt-5 max-w-[38rem] text-[0.98rem] md:text-[1.04rem] leading-relaxed text-[#475569]">
            Ansprechpartner ist Furkan Yildiz. Wir begleiten Personen mit Pflegegrad und Alltagshilfe nach §45b SGB XI mit klaren Leistungen für Zuhause, Organisation und Begleitung.
          </p>
        </div>

        <div className="grid gap-6 md:gap-7 lg:grid-cols-12 lg:items-start">
          <div className="lg:col-span-5">
            <div className="relative h-full overflow-hidden rounded-[30px] border border-[#D9EEFF]/80 bg-[linear-gradient(160deg,rgba(255,255,255,0.98),rgba(248,250,252,0.97),rgba(238,246,255,0.94))] p-6 md:p-7 shadow-[0_22px_56px_rgba(15,23,42,0.06),0_10px_24px_rgba(2,127,219,0.06)]">
              <div className="pointer-events-none absolute inset-x-0 top-0 h-20 bg-[linear-gradient(180deg,rgba(217,238,255,0.45),rgba(217,238,255,0))]" />

              <div className="relative flex items-start gap-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[linear-gradient(135deg,#027FDB,#4DAEFF)] text-white text-lg border border-[#D9EEFF] shadow-[0_10px_22px_rgba(2,127,219,0.16)] shrink-0">
                  <i className="ri-user-heart-line" aria-hidden="true" />
                </div>
                <div>
                  <p className="text-[0.95rem] md:text-[1rem] font-semibold text-[#0F172A]">Für wen Alltagsstern da ist</p>
                  <p className="mt-1 text-sm leading-relaxed text-[#475569]">Für Personen mit Pflegegrad, die im Alltag verlässliche Hilfe brauchen, und für Angehörige, die spürbar entlastet werden sollen.</p>
                </div>
              </div>

              <p className="relative mt-5 text-sm md:text-[0.98rem] leading-relaxed text-[#475569]">
                Wir helfen dort, wo Routinen schwerer werden: bei Wohnungsreinigung, Wäschepflege, Einkaufen, Kochen, Terminen, Mobilitätshilfe und Alltagsorganisation. Persönlich, planbar und nah am Alltag.
              </p>

              <div className="mt-6 space-y-3">
                <div className="flex items-start gap-3 rounded-2xl border border-[#D9EEFF] bg-white/90 px-4 py-3">
                  <i className="ri-check-line mt-0.5 text-[#027FDB] text-base" aria-hidden="true" />
                  <p className="text-sm leading-relaxed text-[#475569]">Für Betroffene mit Pflegegrad und Bedarf an verlässlicher Alltagshilfe.</p>
                </div>
                <div className="flex items-start gap-3 rounded-2xl border border-[#D9EEFF] bg-white/90 px-4 py-3">
                  <i className="ri-check-line mt-0.5 text-[#027FDB] text-base" aria-hidden="true" />
                  <p className="text-sm leading-relaxed text-[#475569]">Für Angehörige, die Organisation und Belastung reduzieren möchten.</p>
                </div>
                <div className="flex items-start gap-3 rounded-2xl border border-[#D9EEFF] bg-white/90 px-4 py-3">
                  <i className="ri-check-line mt-0.5 text-[#027FDB] text-base" aria-hidden="true" />
                  <p className="text-sm leading-relaxed text-[#475569]">Berlinweit mit klarem Fokus auf Alltagshilfe nach §45b SGB XI.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid gap-5 md:gap-6 md:grid-cols-2 auto-rows-auto content-start self-start">
            <div className="group h-fit rounded-[28px] border border-[#D9EEFF] bg-white p-5 md:p-6 shadow-[0_16px_36px_rgba(15,23,42,0.045)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_22px_46px_rgba(15,23,42,0.07)]">
              <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-2xl bg-[#EAF4FF] text-[#027FDB] text-lg border border-[#D9EEFF] shadow-[0_8px_20px_rgba(2,127,219,0.06)]">
                <i className="ri-home-heart-line" aria-hidden="true" />
              </div>
              <h3 className="text-[1rem] md:text-[1.08rem] font-semibold text-[#0F172A]">Was wir konkret übernehmen</h3>
              <p className="mt-3 text-sm md:text-[0.96rem] leading-relaxed text-[#475569]">
                Wohnungsreinigung, Wäschepflege, Fensterreinigung, Einkaufen, Botengänge, Kochen und verlässliche Unterstützung bei wiederkehrenden Alltagsaufgaben.
              </p>
            </div>

            <div className="group h-fit rounded-[28px] border border-[#D9EEFF] bg-[linear-gradient(160deg,rgba(255,255,255,0.98),rgba(248,250,252,0.96),rgba(234,244,255,0.92))] p-5 md:p-6 shadow-[0_16px_36px_rgba(2,127,219,0.06)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_22px_46px_rgba(2,127,219,0.08)]">
              <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-2xl bg-[#EAF4FF] text-[#027FDB] text-lg border border-[#D9EEFF] shadow-[0_8px_20px_rgba(2,127,219,0.06)]">
                <i className="ri-shield-check-line" aria-hidden="true" />
              </div>
              <h3 className="text-[1rem] md:text-[1.08rem] font-semibold text-[#0F172A]">Warum das Vertrauen schafft</h3>
              <p className="mt-3 text-sm md:text-[0.96rem] leading-relaxed text-[#475569]">
                Klare Leistungen, persönliche Kommunikation und ein fester Ansprechpartner statt vager Versprechen.
              </p>
            </div>

            <div className="rounded-[30px] border border-[#D9EEFF] bg-[linear-gradient(160deg,rgba(255,255,255,0.98),rgba(238,246,255,0.95),rgba(255,255,255,0.98))] p-5 md:p-6 md:col-span-2 shadow-[0_18px_42px_rgba(2,127,219,0.06)]">
              <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between md:gap-6">
                <div className="max-w-[30rem]">
                  <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-2xl bg-[#EAF4FF] text-[#027FDB] text-lg border border-[#D9EEFF] shadow-[0_8px_20px_rgba(2,127,219,0.06)]">
                    <i className="ri-user-heart-line" aria-hidden="true" />
                  </div>
                  <h3 className="text-[1rem] md:text-[1.08rem] font-semibold text-[#0F172A]">Worauf Angehörige und Betroffene achten können</h3>
                  <p className="mt-3 text-sm md:text-[0.96rem] leading-relaxed text-[#475569]">
                    Verständliche Alltagshilfe mit klarer Kommunikation, festen Aufgaben und persönlicher Begleitung durch Alltagsstern Haushaltshilfe.
                  </p>
                </div>

                <div className="grid gap-3 grid-cols-1 w-full md:w-auto md:min-w-[15.5rem] md:max-w-[17.5rem] md:justify-items-stretch md:self-start">
                  <div className="w-full rounded-2xl border border-[#D9EEFF] bg-white/90 px-4 py-3.5 text-center min-w-0">
                    <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-[#027FDB]">Berlinweit</p>
                    <p className="mt-1.5 text-sm font-medium text-[#0F172A]">In Berlin erreichbar</p>
                  </div>
                  <div className="w-full rounded-2xl border border-[#D9EEFF] bg-white/90 px-4 py-3.5 text-center min-w-0">
                    <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-[#027FDB]">§45b SGB XI</p>
                    <p className="mt-1.5 text-sm font-medium text-[#0F172A]">Alltagshilfe mit Fokus</p>
                  </div>
                  <div className="w-full rounded-2xl border border-[#D9EEFF] bg-white/90 px-4 py-3.5 text-center min-w-0">
                    <p className="text-[10px] font-semibold uppercase tracking-[0.16em] text-[#027FDB]">Ansprechpartner</p>
                    <p className="mt-1.5 text-sm font-medium text-[#0F172A]">Furkan Yildiz</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
